<template>
  <parent>
    <form-wrapper
      full-width
      full-height
    >
      <template v-slot:body>
        <paper-simple class="h-100 m-auto">
          <p>
            A role contains a set of permissions that allows you to perform
            specific actions on Captain resources. To make permissions available
            to users, you grant roles to the members.
          </p>
          <ul>
            <li class="mt-1">
              <span class="text-thicker">
                Owner:
              </span>
              The owner of the organization with all editor permissions and
              permissions for the following actions: Manage roles and
              permissions for the organization and all resources within the
              organization. Set up billing for the organization.
            </li>
            <li class="mt-1">
              <span class="text-thicker">
                Editor:
              </span>
              All viewer permissions, plus permissions for actions that modify
              state, such as changing existing resources.
            </li>
            <li class="mt-1">
              <span class="text-thicker">
                Viewer:
              </span>
              Permissions for read-only actions that do not affect the state,
              such as viewing (but not modifying) existing resources or data.
            </li>
          </ul>
          <loading-page v-if="loading" />
          <div class="users">
            <div class="mt-2 col-12 col-md-8 d-flex m-auto">
              <b-form-input
                :value="user.email"
                disabled
              />
              <b-form-select
                v-if="!fetchingRoles"
                v-model="roleId"
                :options="roleOptions"
              />
            </div>
          </div>
        </paper-simple>
      </template>
      <template v-slot:footer>
        <b-button
          variant="bg-white"
          @click="onCancel()"
        >
          Cancel
        </b-button>
        <button-loading
          variant="bg-primary"
          class="ml-1"
          :spinning="updatingUser"
          @click="onSave()"
        >Save Changes</button-loading>
      </template>
    </form-wrapper>
  </parent>
</template>
<script>
import redirectError from '@/services/redirectError'

export default {
  data() {
    return {
      roleId: null,
      roleOptions: [],
      user: {},
    }
  },
  computed: {
    loading() {
      return this.$store.state.organization.gettingUser
    },
    updatingUser() {
      return this.$store.state.organization.updatingUser
    },
    fetchingRoles() {
      return this.$store.state.roles.fetchingRoles
    },
  },
  created() {
    this.id = this.$route.params.id

    this.$store
      .dispatch('roles/fetchRoles', {
        pageIndex: 0,
        pageSize: 500,
      })
      .then(() => {
        const role = this.$store.state.roles.roles

        for (let i = 0; i < role.length; i++) {
          this.roleOptions.push({ value: role[i].id, text: role[i].name })
        }
      })

    this.$store
      .dispatch('organization/getUser', this.id)
      .then(() => {
        this.user = this.$store.state.organization.user
        this.roleId = this.user.role.id
      })
      .catch(err => redirectError(err, this.$router, this.$route.path))
  },
  methods: {
    onCancel() {
      this.$router.push({ name: 'organization-settings', query: { tab: '1' } })
    },
    onSave() {
      const query = {
        userId: this.id,
        roleId: this.roleId,
      }
      this.$store
        .dispatch('organization/updateUser', query)
        .then(() => {
          this.successToast('User was updated')
          this.onCancel()
        })
        .catch(error => {
          this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while updating user.')
        })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .paper {
    @media (min-width: 1200px) {
      width: 75%;
    }
  }
}
.users {
  border-top: 1px solid #e0e5eb;
  padding-top: 24px;
}
</style>
